import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
      iconfont: 'mdi',
    },
    global: {
      ripple: false
    },
    theme: {
      themes: {
        light: {
          primary: '#435058',
          secondary: '#6c757d',
          accent: '#FF0080',
          error: '#dc3545',
          petrol: '#17a499',
          background: '#EEF0F2',
          bmbackground: '#fff',
          textinput: '#000',
          lightgreen: '#00B019',
          success:'#50AF35',
          bmbtncolor:"#232D3F"
        },
        dark: {
          primary: '#474747',
          secondary: '#6c757d',
          accent: '#FF0080',
          error: '#dc3545',
          petrol: '#17a499',
          background: '#141823',
          bmbackground: '#232D3F',
          textinput: '#fff',
          lightgreen: '#00B019',
          success:'#50AF35',
          bmbtncolor:"#60697E"
        },
      },
      options: {
        customProperties: true,
      },
    },
  });
